import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { GenericLinkModule, IconModule } from '@spartacus/storefront'
import { UserProfileModule } from '@spartacus/user'
import { EbFormModule } from '../../form/eb-form.module'
import { EbApprovalOfDataPolicyConverter } from '../common/converters/eb-approval-of-data-policy.converter'
import { EbPersonalInfoConverter } from '../common/converters/eb-personal-info.converter'
import { EbCommonFormModule } from '../common/eb-common-form.module'
import { EbContactFormComponent } from './components/contact-form/eb-contact-form.component'
import { EbContactFormRfpHintComponent } from './components/contact-form-rfp-hint/eb-contact-form-rfp-hint.component'
import {
  CONTACT_US_SERIALIZER,
  CONTACT_US_TOPICS_NORMALIZER
} from './converters/eb-contact-us-converters'
import { EbContactUsTopicsNormalizer } from './converters/eb-contact-us-topics.normalizer'
import { EbContactFormAdapter } from './services/connectors/eb-contact-form.adapter'
import { EbContactFormConfigService } from './services/facades/eb-contact-form-config.service'
import { EbContactFormService } from './services/facades/eb-contact-form.service'

@NgModule({
  imports: [
    EbFormModule,
    ReactiveFormsModule,
    CommonModule,
    IconModule,
    I18nModule,
    UserProfileModule,
    GenericLinkModule,
    EbCommonFormModule
  ],
  exports: [EbContactFormComponent],
  declarations: [EbContactFormComponent, EbContactFormRfpHintComponent],
  providers: [
    provideConfig({
      cmsComponents: {
        ebContactFormComponent: {
          component: EbContactFormComponent
        }
      }
    } as CmsConfig),
    EbContactFormConfigService,
    EbContactFormService,
    EbContactFormAdapter,
    {
      provide: CONTACT_US_TOPICS_NORMALIZER,
      useClass: EbContactUsTopicsNormalizer,
      multi: true
    },
    {
      provide: CONTACT_US_SERIALIZER,
      useClass: EbApprovalOfDataPolicyConverter,
      multi: true
    },
    {
      provide: CONTACT_US_SERIALIZER,
      useClass: EbPersonalInfoConverter,
      multi: true
    }
  ]
})
export class EbContactFormModule {}
